const initialState = {
    isAuthenticated: false,
    user: {}
};


const isEmpty = value =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0);

  
export default (state = initialState, action) => {
    switch (action.type) {
        case 'LOGIN':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                user: action.payload
            };
        case 'LOGOUT':
            return {}
        default:
            return state;
    }
};






// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.js